import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link,
  ShirtAddIcon,
  Typography,
} from '@customink/pigment-react';
import type {
  Complement,
  ProjectItem,
} from '@customink/project-service-react-components';
import { useProduct } from '@customink/project-service-react-components';

import ComplementsGrid from './ComplementsGrid';

import { colorBlue, spacing16, spacing8 } from '@/utils/designTokens';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const defaultEmptyHandler = () => {};

type ComplementsAccordionProps = {
  onAddCompatible: () => void;
  onSelectComplement: (complement: Complement) => void;
  projectItems: ProjectItem[];
};

export default function ComplementsAccordion({
  onAddCompatible = defaultEmptyHandler,
  onSelectComplement = defaultEmptyHandler,
  projectItems,
}: ComplementsAccordionProps) {
  const { data: anchorProduct } = useProduct({
    colorId: projectItems[0].product?.colorId,
  });
  const showCatalogLink = !!anchorProduct?.compatible_type;

  return (
    <Accordion
      data-testid="complements-accordion"
      disableGutters
      elevation={0}
      sx={{ position: 'static' }}
    >
      <AccordionSummary>
        <Box display="flex">
          <ShirtAddIcon color="blue" />
          <Link
            fontWeight="semiBold"
            sx={{
              paddingLeft: spacing8,
              '&:hover': {
                backgroundColor: 'transparent',
                color: colorBlue,
                textDecoration: 'none',
              },
              alignItems: 'center',
              display: 'flex',
              margin: '2px 0 0',
            }}
            variant="bodyShort2"
          >
            Add Design to More Styles
          </Link>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <ComplementsGrid
          onSelectComplement={onSelectComplement}
          projectItems={projectItems}
        />
      </AccordionDetails>
      {showCatalogLink && (
        <Box sx={{ padding: `0 ${spacing16} ${spacing16}` }}>
          <Typography variant="heading5">Find more products</Typography>
          <Link onClick={onAddCompatible} variant="bodyShort1">
            Browse the rest of our catalog.
          </Link>
        </Box>
      )}
    </Accordion>
  );
}
